const data = {
	"width": 32,
	"height": 32,
	"body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 10v18h24V10M2 4v6h28V4Zm10 11h8\"/>"
};
export default data;
